import React, { Component } from "react";
import PropTypes from "prop-types";
import Page from "../Page";
import { CheckRule } from "../../common";
import $ from "jquery";
import _ from "lodash";

class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1,
      draft: false,
      isLoading: false
    };
  }

  handleClick(e) {
    this.props.onSubmit(false);
  }
  findPos(obj) {
    var curtop = 0;
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
      return [curtop];
    }
  }
  handleSelect(index, i) {
    let y = 0;

    y = this.findPos(document.getElementById("page" + Number(i)));

    $("#divScroll").animate({ scrollTop: y - 80 }, 400);

    this.setState({ activeIndex: index });
  }

  renderPages() {
    var pages = [];
    var active;
    var i = 1;

    var z = 0;
    var t = 0;
    var r = 0;

    var pagebreaks = _.filter(this.props.pages, { element_type: "25" });

    if (pagebreaks.length > 0) {
      this.props.pages.forEach((page, index) => {
        if (page.element_type === "25" && this.props.pageNums[i] === 1) {
          this.state.activeIndex === z - 1 - t
            ? (active = true)
            : (active = false);

          pages.push(
            <Page
              active={active}
              ref={"tt" + i}
              index={r == 1 ? z - 1 : z}
              onClick={this.handleSelect.bind(this)}
              title={page.element_prompt}
              number={z - 1 - t}
              key={index}
            />
          );
          i += 1;
          if (r === 1) {
            r = 0;
          }
          t = 0;
        } else {
          if (page.element_type === "25" && this.props.pageNums[i] === 0) {
            i += 1;
          } else {
            z += 1;

            if (page.element_type !== "24" && page.element_type !== "22") {
              t += 1;
            }
          }
        }
      });
    } else {
      let newpages = _.filter(this.props.pages, function(page) {
        return page.element_type !== "25";
      });

      newpages.forEach((page, index) => {
        if (page.element_params !== null) {
          if (page.element_params.show_in_menu !== undefined) {
            if (page.element_params.show_in_menu === "1") {
              let element = "";
              let value_x = "";
              let show = "";
              switch (page.element_condition.action) {
                case "":
                  this.state.activeIndex === i
                    ? (active = true)
                    : (active = false);
                  pages.push(
                    <Page
                      active={active}
                      ref={"tt" + i}
                      index={i}
                      onClick={this.handleSelect.bind(this)}
                      title={page.element_prompt}
                      number={i}
                      key={index}
                    />
                  );

                  break;
                case "show":
                  page.element_condition.roles.forEach(elementr => {
                    element = _.filter(this.props.draft, function(draft) {
                      return (
                        Number(draft.element_id) === Number(elementr.c_control)
                      );
                    });

                    if (element.length === 1) {
                      let uid = this.props.repeatingFormUUID;

                      element = _.filter(element, function(draft) {
                        return draft.repeatingFormUUID === uid;
                      });
                      if (element.length > 0) {
                        value_x = element[0].element_value;
                      }
                    } else {
                      if (element.length > 1) {
                        let uid = this.props.repeatingFormUUID;

                        element = _.filter(element, function(draft) {
                          return draft.repeatingFormUUID === uid;
                        });

                        if (element.length > 0) {
                          if (element.length > 1) {
                            element = _.filter(element, function(draft) {
                              return draft.repeatingFormEdit === true;
                            });
                            value_x = element[0].element_value;
                          } else {
                            value_x = element[0].element_value;
                          }
                        }
                      }
                    }

                    show = CheckRule(show, value_x, elementr);
                  });
                  if (show === "") {
                    show = false;
                  } else {
                    show = (" " + show)
                      .replace("  && ", "")
                      .replace("  || ", "");
                  }
                  if (eval(show)) {
                    this.state.activeIndex === i
                      ? (active = true)
                      : (active = false);
                    pages.push(
                      <Page
                        active={active}
                        ref={"tt" + i}
                        index={i}
                        onClick={this.handleSelect.bind(this)}
                        title={page.element_prompt}
                        number={i}
                        key={index}
                      />
                    );
                  }

                  break;
                case "hide":
                  page.element_condition.roles.forEach(elementr => {
                    element = _.filter(this.props.draft, function(draft) {
                      return (
                        Number(draft.element_id) === Number(elementr.c_control)
                      );
                    });

                    if (element.length === 1) {
                      let uid = this.props.repeatingFormUUID;

                      element = _.filter(element, function(draft) {
                        return draft.repeatingFormUUID === uid;
                      });
                      if (element.length > 0) {
                        value_x = element[0].element_value;
                      }
                    } else {
                      if (element.length > 1) {
                        let uid = this.props.repeatingFormUUID;
                        element = _.filter(element, function(draft) {
                          return draft.repeatingFormUUID === uid;
                        });
                        if (element.length > 0) {
                          if (element.length > 1) {
                            element = _.filter(element, function(draft) {
                              return draft.repeatingFormEdit === true;
                            });
                            value_x = element[0].element_value;
                          } else {
                            value_x = element[0].element_value;
                          }
                        }
                      }
                    }

                    show = CheckRule(show, value_x, elementr);
                  });
                  if (show === "") {
                    show = false;
                  } else {
                    show = (" " + show)
                      .replace("  && ", "")
                      .replace("  || ", "");
                  }
                  if (!eval(show)) {
                    this.state.activeIndex === i
                      ? (active = true)
                      : (active = false);
                    pages.push(
                      <Page
                        active={active}
                        ref={"tt" + i}
                        index={i}
                        onClick={this.handleSelect.bind(this)}
                        title={page.element_prompt}
                        number={i}
                        key={index}
                      />
                    );
                  }

                  break;
              }
            }
          }
        }
        i += 1;
      });
    }

    if (pages.length === 0) {
      return <div></div>;
    }

    return (
      <div>
        <div
          style={{
            height: this.props.height - 300 + "px",
            borderTopRightRadius: "6px",
            overflowY: "auto",
            overflowX: "hidden"
          }}
        >
          {pages}
        </div>
      </div>
    );
  }

  handleDraft(e) {
    this.setState({ draft: true });
    this.props.onSubmit(true);
  }

  doPreview() {
    if (!this.props.isReady) {
      setTimeout(() => {
        this.doPreview();
      }, 1000);
    } else {
      this.setState({ isLoading: false });
      this.props.onPreview();
    }
  }

  handlePreview(e) {
    if (!this.props.isReady) {
      this.setState({ isLoading: true });
      setTimeout(() => {
        this.doPreview();
      }, 1000);
    } else {
      this.props.onPreview();
    }
  }

  renderDraftButton() {
    const { submitting, preview } = this.props;

    if (submitting && this.state.draft && !preview) {
      return (
        <button
          disabled
          className="ui button submit"
          onClick={this.handleDraft.bind(this)}
          role="button"
        >
          Save as draft
        </button>
      );
    }

    return (
      <button
        className="ui button submit"
        onClick={this.handleDraft.bind(this)}
        role="button"
      >
        Save as draft
      </button>
    );
  }

  handleApprove(e) {
    this.props.onApprove();
  }

  handleReject(e) {
    this.props.onReject();
  }

  renderRejectButton() {
    return (
      <button
        className="ui button submit"
        style={{ marginBottom: 15 }}
        onClick={this.handleReject.bind(this)}
        role="button"
      >
        Reject
      </button>
    );
  }
  renderApproveButton() {
    return (
      <button
        className="ui button submit"
        style={{ marginBottom: 15 }}
        onClick={this.handleApprove.bind(this)}
        role="button"
      >
        Approve
      </button>
    );
  }

  renderPreviewButton = (submitting, preview) => (
      <button
            loading={submitting && preview}
            disabled={!this.props.isConnected}
            className="ui button submit"
            style={{ marginBottom: 15 }}
            onClick={this.handlePreview.bind(this)}
            role="button"
          >
            {submitting && preview ? "Cancel" : "Preview"}
      </button>
    );

  renderNewTaskButton = () => (
    <button
      className="ui button submit"
      style={{ marginBottom: 15 }}
      onClick={this.props.onCreateTask}
      role="button"
    >
      New Task
    </button>
  );   

  renderSubmitButton = () => (
    <button
      className="ui button submit"
      style={{ marginBottom: 15 }}
      onClick={this.handleClick.bind(this)}
      role="button"
    >
      Submit
    </button>
  );    

  renderButtons() {
    const { submitting, preview, isLoading, exists, isApprover, previewEnabled, tasksEnabled } = this.props;

    if (isLoading || !exists) {
      return null;
    }

    return (
      <div
        style={{
          position: "absolute",
          padding: "20px",
          width: "100%",
          bottom: "60px"
        }}
      >
        {tasksEnabled && this.renderNewTaskButton()}
        {previewEnabled && this.renderPreviewButton(submitting, preview)}
        {isApprover && this.renderRejectButton()}
        {isApprover && this.renderApproveButton()}
        {!isApprover && this.renderSubmitButton()}
        {this.renderDraftButton()}
      </div>
    );   
  }

  render() {
    const { height } = this.props;

    return (
      <div
        style={{
          float: "left",
          width: "210px",
          height: height + "px",
          marginTop: "0px",
          paddingTop: "10px",
          backgroundColor: "#e6e6e6"
        }}
      >
        <div
          className="ui vertical pointing menu middle aligned selection list"
          style={{ borderTopRightRadius: "5px" }}
        >
          {this.renderPages()}
          {this.renderButtons()}
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  height: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onPreview: PropTypes.func.isRequired,
  onCreateTask: PropTypes.func.isRequired,
  isConnected: PropTypes.bool.isRequired,
  draft: PropTypes.array.isRequired,
  isReady: PropTypes.bool.isRequired,
  onPreview: PropTypes.func.isRequired,
  pageNums: PropTypes.array.isRequired,
  storeColour: PropTypes.object.isRequired
};

export default Pages;



// WEBPACK FOOTER //
// ./src/components/Pages/index.js